import { Helmet } from 'react-helmet-async'
import PageLayout from '../components/layout/PageLayout.jsx'
import SectionHeading from '../components/ui/SectionHeading.jsx'
import PharmaCard from '../components/ui/PharmaCard.jsx'
import { researchFacilities } from '../data/researchFacilities.js'
import { motion } from 'framer-motion'

export default function ResearchDevelopment() {
  return (
    <PageLayout>
      <Helmet>
        <title>Research & Development | Ritik Medicare Pvt. Ltd.</title>
        <meta
          name="description"
          content="Explore Ritik Medicare R&D: research facilities, innovation, development process and laboratory excellence." 
        />
      </Helmet>

      <section className="bg-sectionBg">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:py-16">
          <SectionHeading
            eyebrow="R&D"
            title="Research Facilities & Laboratory Excellence"
            subtitle="From innovation to validated scale-up planning." 
          />

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {researchFacilities.map((x) => (
              <PharmaCard key={x.title} title={x.title} desc={x.desc} className="bg-white/80" />
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6 items-start"
          >
            <div className="lg:col-span-7 rounded-3xl border border-slate-200 bg-white/70 p-6">
              <div className="font-extrabold text-slate-900">Development Process</div>
              <p className="mt-2 text-sm sm:text-[16px] text-slate-600 leading-relaxed">
                We use a controlled, documentation-first development workflow to reduce risk during scale-up. This includes
                structured feasibility studies, method planning, analytics and thorough reporting.
              </p>
              <ul className="mt-4 space-y-2 text-sm text-slate-700">
                {[
                  'Feasibility & route evaluation',
                  'Experiment design and controlled iterations',
                  'Analytical method development and validation planning',
                  'Tech transfer documentation support',
                ].map((t) => (
                  <li key={t} className="flex items-start gap-2">
                    <span className="mt-1 w-2 h-2 rounded-full bg-brand-accent" />
                    {t}
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-5 rounded-3xl bg-white p-6 border border-slate-200">
              <div className="font-extrabold text-slate-900">Innovation</div>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                Continuous improvement in route efficiency, yield and purity—supported by analytical excellence.
              </p>
              <div className="mt-4 space-y-3">
                {[
                  { t: 'Laboratory Excellence', d: 'Reliable analytical capability for quality goals.' },
                  { t: 'Documentation-first', d: 'Structured reports and traceability for regulated operations.' },
                ].map((x) => (
                  <div key={x.t} className="rounded-2xl border border-slate-200 bg-sectionBg p-4">
                    <div className="font-bold text-slate-900">{x.t}</div>
                    <div className="text-sm text-slate-600 mt-1">{x.d}</div>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </PageLayout>
  )
}

